import { render, staticRenderFns } from "./TextblockMultiple.vue?vue&type=template&id=27396ea1"
import script from "./TextblockMultiple.vue?vue&type=script&lang=js"
export * from "./TextblockMultiple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports